<script setup lang="ts">
import OrderList from "@/views/playground/planner/business-management/settlement-management/revenue/OrderList.vue";
</script>
<template>
  <order-list></order-list>
</template>
<style scoped></style>
